import React from 'react';
import styled from 'styled-components';

import ArrowLeft from '../../../../../../../icons/arrow-left.svg';
import ArrowRight from '../../../../../../../icons/arrow-right.svg';

const Button = (props) => {
  const { direction = 'right', onClick } = props;

  return (
    <StyledButton direction={direction} onClick={onClick}>
      <StyledArrowIcon>
        {direction === 'right' && <ArrowRight />}
        {direction === 'left' && <ArrowLeft />}
      </StyledArrowIcon>
    </StyledButton>
  );
};

const StyledButton = styled.button`
  position: absolute;
  background-color: var(--blue-dark);
  border: none;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 46px;
  height: 46px;
  bottom: 15px;
  ${({ direction }) =>
    direction === 'right' ? 'right: 15px;' : 'right: 80px;'}
  transition: filter 0.3s ease-in-out;

  &:hover {
    filter: brightness(98%);
  }
`;

const StyledArrowIcon = styled.div`
  display: block;
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    width: 14px;
    height: 14px;
    path {
      fill: var(--teal-light);
    }
  }
`;

export default Button;
